<template>
  <div>
    <div class="ValidatorBetail">
      <div class="ValidatorBetail-W">
        <div class="Homeinput"></div>
        <!-- <div class="BkHeight_conent">
          <div class="BkHeight_conent_header">
            <p>
              <span>Overview</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <ul>
              <li>
                <p>Token :</p>
                <p>
              
                  <img :src="logo" style="border-radius: 50%;width: 40px;height: 40px;" />
                 <span> {{ contractName }}</span>
                <span v-if="symbol.trim() !==''">(</span>
                 <span v-if="symbol.trim() !==null || symbol.trim() !==''"> {{ symbol }}</span>
                 <span v-if="symbol.trim() !==''">)</span>
                </p>
              </li>
              <li>
                <p>Supply :</p>
                <p style="word-wrap: break-word;word-break:break-all;line-height: 24px;height: 62px;margin-top: 16px;">{{ supply }}</p>
              </li>
              <li>
                <p>Transactions :</p>
                <p>{{ txCount }}</p>
              </li>
              <li>
                <p>Contract :</p>
                <p>{{ contractAddress }}</p>
              </li>
              <li>
                <p>Holders :</p>
                <p>{{ holders }}</p>
              </li>
              <li>
                <p>Creator :</p>
                <p @click="Address(creator)">{{ creator }}</p>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="overbox">
          <div class="overboxli">
            <div class="overtit">Overview</div>
            <div class="overtit1">
              <div class="tit">Token :</div>
              <div class="con">
                <img
                  :src="logo"
                  style="
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    margin-top: -10px;
                    margin-right: 6px;
                  "
                />
                <div class="name">
                  <span> {{ contractName }}</span>
                  <span v-if="symbol.trim() !== ''">(</span>
                  <span v-if="symbol.trim() !== null || symbol.trim() !== ''">
                    {{ symbol }}</span
                  >
                  <span v-if="symbol.trim() !== ''">)</span>
                </div>
              </div>
            </div>
            <div class="overtit1">
              <div class="tit">Total Supply :</div>
              <div class="con">
                <div class="name" v-if="supply !=='——'">{{ Number(supply).toLocaleString() }}</div>
                <div class="name" v-else>{{ supply }}</div>
              </div>
            </div>
            <div class="overtit1">
              <div class="tit">Holders :</div>
              <div class="con">
                <div class="name">{{ holders }}</div>
              </div>
            </div>
            <div class="overtit1">
              <div class="tit">Transfers :</div>
              <div class="con">
                <div class="name" v-if="txCount>999">{{ Number(txCount).toLocaleString() }}</div>
                <div class="name" v-else>{{ txCount }}</div>
              </div>
            </div>
          </div>
          <div class="overboxli">
            <div class="overtit">
              Other Info
              <img
                v-if="isEditContractInfo == 1"
                class="imga"
                src="../../../assets/pc/Logo/over3.png"
                @click="update"
              />
            </div>
            <div class="overtit1">
              <div class="tit1">Contract :</div>
              <div
                class="con"
               
              >
               <div  style="
                  width: 388px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  -o-text-overflow: ellipsis;
                ">{{ contractAddress }}</div> 
                <img
                 src="@/assets/pc/BkHash/BkHash1.png"
                  v-clipboard:copy="contractAddress"
                  v-clipboard:success="copyClicked"
                  v-clipboard:error="onError"
                  class="copys"
                />
              </div>
            </div>
            <div class="overtit1">
              <div class="tit1">Creator :</div>
              <div
                class="con"
                style="color: #fff; cursor: pointer; width: 392px"
               
              >
               <span  @click="Address(creator)"> {{ creator }}</span>
                <img
                src="@/assets/pc/BkHash/BkHash1.png"
                  v-clipboard:copy="creator"
                  v-clipboard:success="copyClicked"
                  v-clipboard:error="onError"
                  class="copys"
                />
              </div>
            </div>
            <div
              class="overtit1"
              v-if="
                this.form.whitepapper !== '' ||
                this.form.medium !== '' ||
                this.form.github !== '' ||
                this.form.reddit !== '' ||
                this.form.telegram !== '' ||
                this.form.facebook !== '' ||
                this.form.linkedin !== '' ||
                this.form.twitter !== '' ||
                this.form.discord !== '' ||
                this.form.opensea !== '' ||
                this.form.officialWebSite !== ''
              "
            >
              <div class="tit">Social :</div>
              <div
                class="con"
                style="
                  width: 370px;
                  display: flex;
                  flex-wrap: wrap;
                  height: 100px;
                "
              >
                <a
                  :href="this.form.officialWebSite"
                  target="_blank"
                  v-if="this.form.officialWebSite !== ''"
                >
                  <img
                    class="imga"
                    v-if="this.form.officialWebSite !== ''"
                    src="../../../assets/pc/Link/11.png"
                  />
                </a>
                <a
                  :href="this.form.whitepapper"
                  target="_blank"
                  v-if="this.form.whitepapper !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/1.png" />
                </a>
                <a
                  :href="this.form.github"
                  target="_blank"
                  v-if="this.form.github !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/3.png" />
                </a>
                <a
                  :href="this.form.reddit"
                  target="_blank"
                  v-if="this.form.reddit !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/4.png" />
                </a>
                <a
                  :href="this.form.telegram"
                  target="_blank"
                  v-if="this.form.telegram !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/5.png" />
                </a>
                <a
                  :href="this.form.facebook"
                  target="_blank"
                  v-if="this.form.facebook !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/6.png" />
                </a>
                <a
                  :href="this.form.linkedin"
                  target="_blank"
                  v-if="this.form.linkedin !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/7.png" />
                </a>
                <a
                  :href="this.form.twitter"
                  target="_blank"
                  v-if="this.form.twitter !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/8.png" />
                </a>
                <a
                  :href="this.form.discord"
                  target="_blank"
                  v-if="this.form.discord !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/9.png" />
                </a>
                <a
                  :href="this.form.opensea"
                  target="_blank"
                  v-if="this.form.opensea !== ''"
                >
                  <img class="imga" src="../../../assets/pc/Link/10.png" />
                </a>

                <a
                  :href="this.form.medium"
                  target="_blank"
                  v-if="this.form.medium !== ''"
                >
                  <img
                    class="imga"
                    v-if="this.form.medium !== ''"
                    src="../../../assets/pc/Link/2.png"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div>
          <TokensList
            :contractAddress="contractAddress"
            :supply="supply1"
            :sourceCode="sourceCode"
            :byteCode="byteCode"
            :isChecked="isChecked"
            :license="license"
            :compileVersion="compileVersion"
            :allVersion="allVersion"
            :contractName="contractName"
            :abiJsonall="abiJsonall"
            :deployutxo="deployutxo"
            :creator="creator"
          ></TokensList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubStr } from "@/utils/utils";
import { TokenDetail } from "@/assets/server/api";
import Listbox from "@/components/pc/Listbox.vue";
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input.vue";
import TokensList from "../Tokens/Overviewlist.vue";
export default {
  data() {
    return {
      abiJson: "",
      abiJsonall: [],
      deployutxo: "",
      contractAddress: "",
      symbol: "",
      sourceCode: "",
      byteCode: "",
      holders: "",
      txCount: "",
      logo: "",
      contractName: "",
      supply: "",
      supply1: "",
      creator: "",
      isChecked: "",
      license: "",
      compileVersion: "",
      allVersion: "",
      ImgUrl: require("@/assets/pc/Index/indexlogo.png"),
      isEditContractInfo: "",
      userId: "",
      socialProfiles: "",
      form: {
        opensea: "",
        github: "",
        twitter: "",
        discord: "",
        facebook: "",
        reddit: "",
        whitepapper: "",
        telegram: "",
        medium: "",
        linkedin: "",
        officialWebSite: "",
      },
      imageUrl: "",
      isImage: false,
    };
  },

  components: {
    Homeinput,
    Homseach,
    Listbox,
    TokensList,
  },
  watch: {
    $route: {
      handler: function (to, form) {
        if (to.path === "/pc/Overview") {
          this.contractAddress = to.query.contractAddress;
          //    console.log(this.contractAddress);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.initCharts();
    this.getContractTxList();
    this.userId = localStorage.getItem("userId");
    // console.log(this.userId);
  },
  methods: {
    copyClicked(e) {
      this.$message.success({
        type: "info",
        message: "Content copied to clipboard!",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("Sorry, copy failed！");
    },
    isImageUrl(url) {
      const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"]; // Add more extensions if needed
      const lowercasedUrl = url.toLowerCase();
      const extension = lowercasedUrl.split(".").pop();
      return imageExtensions.includes(extension);
    },
    update() {
      this.$router.push({
        path: "/pc/Information",
        query: { userId: this.userId, contractAddress: this.contractAddress },
      });
    },
    async getContractTxList() {
      let formData = new FormData();
      let params = {
        contractAddress: this.contractAddress,
        userId: localStorage.getItem("userId"),
      };
    //  console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await TokenDetail(formData);
  //    console.log(res);
      this.abiJson = res.result.abiJson;
    //  console.log(this.abiJson);
      if (this.abiJson !== null) {
        if (this.abiJson.length > 0) {
          for (var i = 0; i < this.abiJson.length; i++) {
            // console.log(this.abiJson[i].inputs);
            // console.log(JSON.stringify(this.abiJson[i]))
            if (this.abiJson[i].type == "function") {
              this.abiJsonall.push(this.abiJson[i]);
              //  console.log(this.abiJson[i].inputs);
              //  console.log(this.abiJson[i].outputs);
            }
          }
          for (var j = 0; j < this.abiJsonall.length; j++) {
            this.abiJsonall[j].id = j + 1;
            this.abiJsonall[j].results = "";
            this.abiJsonall[j].resultser = "";
            if (this.abiJsonall[j].inputs.length > 0) {
              for (var n = 0; n < this.abiJsonall[j].inputs.length; n++) {
                this.abiJsonall[j].inputs[n].value = "";
                // this.abiJsonall[j].inputs[n].results="";
                //this.abiJsonall[j].inputs[n].values ='value'+j+n;
              }
            }
          }
       //   console.log(this.abiJsonall);
        }
      }
      // localStorage.setItem('abiJsonall',this.abiJsonall)
      // console.log(this.abiJsonall);
      this.deployutxo = res.result.deployutxo;
      this.symbol = res.result.symbol;
      this.sourceCode = res.result.sourceCode;
      this.byteCode = res.result.byteCode;
      this.isChecked = res.result.isChecked;
      this.license = res.result.license;
      this.compileVersion = res.result.compileVersion;
      this.allVersion = res.result.allVersion;
      this.isEditContractInfo = Number(res.result.isEditContractInfo);
     // console.log(this.isEditContractInfo);
      if (
        res.result.socialProfiles !== " " ||
        res.result.socialProfiles !== null
      ) {
        // this.socialProfiles=res.result.socialProfiles;
        this.socialProfiles = JSON.parse(res.result.socialProfiles);
    //    console.log(this.socialProfiles);
        if (this.socialProfiles !== null) {
          this.form.opensea = this.socialProfiles.opensea;
          this.form.github = this.socialProfiles.github;
        //  console.log(this.form.github);
          this.form.twitter = this.socialProfiles.twitter;
          this.form.discord = this.socialProfiles.discord;
          this.form.facebook = this.socialProfiles.facebook;
          this.form.reddit = this.socialProfiles.reddit;
          this.form.whitepapper = this.socialProfiles.whitepapper;
        //  console.log(this.form.whitepapper);
          this.form.telegram = this.socialProfiles.telegram;
          this.form.medium = this.socialProfiles.medium;
          this.form.linkedin = this.socialProfiles.linkedin;
          this.form.officialWebSite = this.socialProfiles.officialWebSite;
        }
      }

      // isChecked:"",
      // license:"",
      // compileVersion:"",
      // console.log(this.byteCode);
      this.holders = res.result.holders;
      this.txCount = res.result.txCount;

      if (res.result.logo == "" || res.result.logo == null) {
      //  console.log(1111);
        //  console.log(this.checkImage(res.result.logo));
        this.logo = this.ImgUrl;
      } else {
       // console.log(2222);
        this.isImage = this.isImageUrl(res.result.logo);
      //  console.log(this.isImage);
        if (this.isImage == false) {
          this.logo = this.ImgUrl;
        } else {
          this.logo = res.result.logo;
        }
        // console.log(this.logo);
        // console.log(this.checkImage(res.result.logo));
      }
      if (res.result.contractName == "" || res.result.contractName == null) {
        this.contractName = getSubStr(res.result.contractAddress, 0, 3);
      } else {
        this.contractName = res.result.contractName;
      }
      // if(res.result.symbol !==null || res.result.symbol !==''){
      //   this.symbol= '()'+res.result.symbol;
      // }else{
      //   this.symbol="";
      // }
      // this.contractAddress=res.result.contractAddress;

      this.supply1 = res.result.supply;
      this.supply = res.result.supply;
     // console.log(this.supply);
      if (this.supply == "0" || Number(this.supply) == 0) {
        this.supply = "——";
      }
      this.creator = res.result.creator;
    },
    Address(index) {
      this.$router.push({
        path: "/pc/BkHash",
        query: { query: index },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ValidatorBetail {
  width: 100%;
  background: #13161b;
  .ValidatorBetail-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .Homeinput {
      padding: 10px 0;
    }
    // 合约所有权开始
    .overbox {
      display: flex;
      margin-bottom: 20px;
      justify-content: space-between;
      .overboxli {
        width: 570px;
        height: 289px;
        background: #0b0c0f;
        opacity: 1;
        border-radius: 20px;

        .overtit {
          height: 22px;
          font-size: 19px;
          font-family: Roboto, Roboto;
          font-weight: 500;
          color: #ffffff;
          line-height: 22px;
          margin-top: 30px;
          margin-left: 40px;
          .imga {
            width: 24px;
            height: 24px;
            margin-left: 384px;
          }
        }
        .overtit1 {
          display: flex;

          margin-left: 40px;
          margin-top: 30px;
          .tit {
            height: 19px;
            font-size: 16px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;

            line-height: 19px;
            width: 132px;
          }
          .tit1 {
            height: 19px;
            font-size: 16px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;

            line-height: 19px;
            width: 102px;
          }
          .con {
            display: flex;
            height: 19px;
            font-size: 16px;
            font-family: Roboto, Roboto;
            font-weight: 400;
            color: #898b8d;
            line-height: 19px;
            text-align: left;
            // border: 1px solid red;
            .name {
              height: 19px;
              font-size: 16px;
              font-family: Roboto, Roboto;
              font-weight: 400;
              color: #898b8d;
              line-height: 19px;
              // margin-top: 8px;
              // margin-left: 16px;
              text-align: left;
            }

            img {
              width: 37px;
              height: 36px;
              border-radius: 50%;
            }
            .imga {
              width: 26px;
              height: 26px;
              margin-right: 26px;
            }
            .copys{
              width: 24px;
              height: 24px;
              margin-left: 1px;
            }
          }
        }
      }
    }
    // 合约所有权结束
    .BkHeight_conent {
      background: #0b0c0f;
      border-radius: 16px 16px 16px 16px;
      padding: 20px 20px 0 20px;
      margin-bottom: 20px;
      .BkHeight_conent_header {
        p {
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 24px;
            -webkit-background-clip: text;
            margin-left: 40px;
            margin-top: 40px;
          }
        }
      }

      .BkHeight_conent_Ul {
        margin-left: 40px;
        ul {
          li {
            display: flex;
            height: 62px;
            p:nth-child(1) {
              flex: 0 0 12%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              margin-right: 161px;
              img {
                margin-right: 4px;
              }
            }
            p:nth-child(2) {
              display: flex;
              flex: 0 0 60%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 20px;
              line-height: 62px;
              -webkit-background-clip: text;
              span {
                margin-top: 12px;
                // color: red;
                margin-left: 6px;
                display: block;
              }
              img {
                width: 26px;
                height: 26px;
                margin-top: 20px;
              }
            }
          }
          li:nth-child(2) {
            p {
              img {
                width: 24px;
                height: 24px;
                margin-left: 20px;
                cursor: pointer;
              }
            }
          }
          li:nth-child(6) {
            p:nth-child(2) {
              color: #fff;
              cursor: pointer;
            }
            p:nth-child(2):hover {
              color: #00e79a;
            }
          }
        }
      }
    }
    .TopValidatorsList {
      padding-bottom: 40px;
    }
  }
}
.BlockList {
  width: 100%;
  background: #13161b;
  .BlockList-W {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 36px;
    background: #13161b;
    .BlockList_Inp {
      padding: 40px 0;
    }
    .Blockbox {
      margin-bottom: 20px;
      display: flex;
      .box1 {
        width: 295px !important;
      }
      .box2 {
        width: 476px !important;
      }
      .box3 {
        width: 349px !important;
      }
      .Blockboxli {
        width: 373px;
        height: 120px;
        background: #0b0c0f;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 20px;
        .Blocktit {
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
          line-height: 17px;
          margin-top: 30px;
          margin-left: 40px;
        }
        .Blockcon {
          height: 35px;
          font-size: 24px;
          font-family: Source Han Sans CN-Medium, Source Han Sans CN;
          font-weight: 500;
          color: #00e79a;
          line-height: 35px;
          margin-top: 8px;
          margin-left: 40px;
        }
      }
    }
  }
}
</style>
